function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1000 -40) translate(960) translate(40 40)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0D0735",
  d: "M20 13.142c.828 0 1.5.672 1.5 1.5v4h4c.828 0 1.5.672 1.5 1.5 0 .829-.672 1.5-1.5 1.5h-4v4c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5v-4h-4c-.828 0-1.5-.671-1.5-1.5 0-.828.672-1.5 1.5-1.5h4v-4c0-.828.672-1.5 1.5-1.5z",
  transform: "rotate(45 20 20.142)"
}));

function SvgClose(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIj4KICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTAwMCAtNDApIHRyYW5zbGF0ZSg5NjApIHRyYW5zbGF0ZSg0MCA0MCkiPgogICAgPHBhdGggZmlsbD0iIzBEMDczNSIgZD0iTTIwIDEzLjE0MmMuODI4IDAgMS41LjY3MiAxLjUgMS41djRoNGMuODI4IDAgMS41LjY3MiAxLjUgMS41IDAgLjgyOS0uNjcyIDEuNS0xLjUgMS41aC00djRjMCAuODI5LS42NzIgMS41LTEuNSAxLjVzLTEuNS0uNjcxLTEuNS0xLjV2LTRoLTRjLS44MjggMC0xLjUtLjY3MS0xLjUtMS41IDAtLjgyOC42NzItMS41IDEuNS0xLjVoNHYtNGMwLS44MjguNjcyLTEuNSAxLjUtMS41eiIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMjAgMjAuMTQyKSIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgClose as ReactComponent };